import { getApiBaseUrl } from '../../../utils/apiConfig';

const API_BASE_URL = getApiBaseUrl();

/**
 * Batch leve: URLs opacas de foto por codtec (só quem tem S3).
 * @param {string[]} technicianIds
 * @returns {Promise<{ urls: Record<string, string>, ttlSec: number }>}
 */
export async function fetchBoardTechnicianAvatarUrls(technicianIds) {
  const ids = Array.isArray(technicianIds)
    ? [...new Set(technicianIds.map((id) => String(id ?? '').trim()).filter(Boolean))]
    : [];
  if (!ids.length) return { urls: {}, ttlSec: 1800 };

  const token = localStorage.getItem('authToken');
  const res = await fetch(`${API_BASE_URL}/api/users/profile-photos/by-codtec`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ codtecs: ids }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.message || `Erro HTTP ${res.status}`);
  }
  const urls =
    data?.urls && typeof data.urls === 'object' && !Array.isArray(data.urls) ? data.urls : {};
  return {
    urls,
    ttlSec: Number(data?.ttlSec) > 0 ? Number(data.ttlSec) : 1800,
  };
}
